module.exports = __webpack_public_path__ + "static/3-462db10c6051a9530e7ab1347473aea7.jpg";